module.exports = __webpack_public_path__ + "static/media/nav_vimeo.79e5cbf1.svg";